import { Simulation } from '../types/main';


export const getSimulationInLocalStorage = (filiere: string): Simulation | null => {
  // Simulation only used for the name of the properties it contians,
  // not the values
  // let tempSimulation: Simulation;

  // Object.keys(Simulation).forEach((property: 'name' | 'surname' | 'emailAddress' | 'token') => {
  //   tempSimulation[property] = window.localStorage.getItem(`Simulation_${property}`);
  // });

  const tempSimulation = window.localStorage.getItem(`SimuBac2020_${filiere}`);

  return tempSimulation && JSON.parse(tempSimulation);
}


export const updateSimulationInLocalStorage = (Simulation: Simulation): void => {
  // Object.keys(Simulation).forEach((property) => {
  //   window.localStorage.setItem(`Simulation_${property}`, Simulation[property]);
  // });
  window.localStorage.setItem(`SimuBac2020_${Simulation.filiere}`, JSON.stringify(Simulation));
}


export const removeSimulationInLocalStorage = (): void => {
  // Object.keys(Simulation).forEach((property) => {
  //   window.localStorage.removeItem(`Simulation_${property}`);
  // });
  window.localStorage.removeItem('SimuBac2020');
}
